import { ChatComposeBoxAddAttachmentMenuItem } from '@glade-ai/chat-plugin/ui';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

/**
 * Menu item for adding a Payment Gate to a workflow template step.
 *
 * Pair this with the `PaymentGateModal` at the call site:
 * render the menu item in the step-attachment menu; when clicked,
 * open the modal. Save persists to `WorkflowStep.data.paymentGates`
 * via `tsClient.workflows.updateWorkflowStep`.
 *
 * Feature flag: `payment-gate-step-attachment` (PostHog).
 */
const ADD_PAYMENT_GATE_LABEL = 'Payment Gate';
const ADD_PAYMENT_GATE_ICON = 'ph--shield-check--regular';

export const AddPaymentGateMenuItem = forwardRef<
  HTMLDivElement,
  Omit<ComponentPropsWithoutRef<typeof ChatComposeBoxAddAttachmentMenuItem>, 'icon' | 'label'>
>((props, forwardedRef) => (
  <ChatComposeBoxAddAttachmentMenuItem
    {...props}
    ref={forwardedRef}
    icon={ADD_PAYMENT_GATE_ICON}
    label={ADD_PAYMENT_GATE_LABEL}
  />
));
AddPaymentGateMenuItem.displayName = 'AddPaymentGateMenuItem';
